export default __webpack_public_path__ + "images/ca386ed36b0fde4467bfa6e3670cf60b.svg";